import { render, staticRenderFns } from "./CertificateWishes.vue?vue&type=template&id=74272393&scoped=true&"
import script from "./CertificateWishes.vue?vue&type=script&lang=js&"
export * from "./CertificateWishes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74272393",
  null
  
)

export default component.exports